import React from "react";
import "./css/AuthSectionContainer.css";
import PhysioTracker from "../../Landing/components/PhysioTracker";

function AuthSectionContainer({ children, title = "", className }) {
  return (
    <section className={`auth-form-section ${className}`}>
      <div className="section-header">
        <PhysioTracker size={1.1} />
      </div>
      <h2>{title}</h2>
      {children}
    </section>
  );
}

export default AuthSectionContainer;
